import React, { useId } from 'react'
import PropTypes from 'prop-types'

const MaximizeIcon = React.forwardRef(function MaximizeIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29289C21.3166 1.90237 20.6834 1.90237 20.2929 2.29289L13.2929 9.29289C12.9024 9.68342 12.9024 10.3166 13.2929 10.7071C13.6834 11.0976 14.3166 11.0976 14.7071 10.7071L21.7071 3.70711C22.0976 3.31658 22.0976 2.68342 21.7071 2.29289Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 2H15C14.4477 2 14 2.44772 14 3 14 3.55228 14.4477 4 15 4H20V9C20 9.55228 20.4477 10 21 10 21.5523 10 22 9.55228 22 9V2ZM10.7071 13.2929C10.3166 12.9024 9.68342 12.9024 9.29289 13.2929L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071 2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L10.7071 14.7071C11.0976 14.3166 11.0976 13.6834 10.7071 13.2929Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 14C2.44772 14 2 14.4477 2 15V22H9C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20H4V15C4 14.4477 3.55228 14 3 14Z"
      ></path>
    </svg>
  )
})

MaximizeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

MaximizeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default MaximizeIcon
